<template>
  <div class="order container">
    <router-view></router-view>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  name: 'Order',
  metaInfo () {
    return {
      titleTemplate: (titleChunk) => {
        if (this.order && this.order.hotel) {
          return titleChunk ? `${titleChunk} - ${this.order.hotel.hotelName} | ${this.$t('metaInfo.slogan')}` : this.$t('metaInfo.slogan')
        }
        return titleChunk ? `${titleChunk} | ${this.$t('metaInfo.slogan')}` : this.$t('metaInfo.slogan')
      }
    }
  },
  computed: {
    ...mapGetters({
      order: 'order/order'
    })
  },
  methods: {
  },
  created () {
    if (!this.order || _.isEmpty(this.order)) {
      this.$router.replace({
        name: 'Callback',
        query: {
          orderSerial: this.$route.query.orderSerial,
          orderToken: this.$route.query.orderToken
        }
      })
    }
  }
}
</script>

<style lang="sass">
.order
  margin-bottom: 5rem
  &__footer
    @apply w-full
  &__top
    @apply w-full
    @screen lg
      @apply w-2/3
      @apply mr-auto
  &__body
    @apply flex flex-col-reverse
    @screen lg
      @apply flex flex-row flex-wrap justify-center
  &__left
    @apply w-full
    @screen lg
      @apply w-2/3
      @apply pr-12
  &__right
    @apply w-full mb-16
    @screen lg
      @apply w-1/3 mb-0
      @apply pl-12

.rotating
  +animation(rotating 3s infinite ease)

+keyframes(rotating)
  0%
    transform: rotate(0)
    @apply text-grey-light
  50%
    @apply text-orange
  100%
    transform: rotate(360deg)
    @apply text-grey-light
</style>
